var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"bgSt"}},[_c('v-header'),_c('router-view'),_c('s-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }